import React from 'react';
import { Crosshair } from 'react-feather';

import { CLINIC_LIST } from '../data/clinicList';
import { formatPhone } from '../utils';
import styles from './Map.module.css';

const DG = require('2gis-maps');

export const Map: React.FC = () => {
  React.useEffect(() => {
    DG.then(() => {
      const map = DG.map('map', {
        center: [34.92387994570497, 33.00130426883698],
        zoom: 10,
      });
      (window as any).map = map;

      CLINIC_LIST.forEach(clinic => {
        const popup = DG.popup(clinic.coords)
          .setLatLng(clinic.coords)
          .setContent(
            `<strong>${clinic.title}</strong><hr/>${clinic.phones
              .map(formatPhone)
              .join('<br/>')}<br/>${
              clinic.website
                ? `<a href="//${clinic.website}" target="_blank" />${clinic.website}</a>`
                : ''
            }`,
          );

        (window as any)[`popup_${clinic.id}`] = popup;

        DG.marker(clinic.coords, {
          title: clinic.title,
        })
          .addTo(map)
          .bindPopup(popup);
      });

      map.setLang('en');
    });
  }, []);

  return (
    <div className={styles.container}>
      {/* <button
        className={styles.action}
        onClick={() => {
          (window as any).map
            .locate({ setView: true })
            .on('locationfound', (e: any) => {
              (window as any).flyTo([e.latitude, e.longitude], 17);
            });
        }}>
        <Crosshair />
      </button> */}
      <div id='map' className={styles.map} />
    </div>
  );
};
